import { defineMessages } from 'react-intl';

export default defineMessages({
  ContactSupportContactOurSupportTeam: {
    id: 'ContactSupportContactOurSupportTeam',
    defaultMessage: 'Contact our support team',
  },
});
